import { all, takeLatest, put, call, select, delay, take, race, fork } from "redux-saga/effects";
import { toast } from 'react-hot-toast';
import { organizationBillingReportsSearchSlice, selectOrganizationBillingReportsSearchSelectedReports, loadOrganizationBillingReports, viewOrganizationBillingReport, loadOrganizationBillingReportContent, loadOrganizationActivityReports, viewOrganizationActivityReport, loadOrganizationActivityReportContent } from "./slice";
import { loadOrganizations, selectOrganizationsSearchOrganizationsGridParams, selectOrganizationsSearchSelectedOrganizationUsersGridParams, viewOrganization } from "../../../organizations/search/redux/slice";
import { IConfiguration } from "../../../shared/types";
import { selectConfig } from "../../../shared/redux/slice";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { SimplyTestApi } from "../../../api/simplytest";
import { AxiosResponse } from "axios";
import { OrganizationBillingReportsSearchResponse, OrganizationBillingReportSearchResponse, OrganizationActivityReportsSearchResponse, OrganizationActivityReportSearchResponse } from "../../../api/types";

export abstract class OrganizationBillingReportSagas {
    public static* run() {
        try {
            yield takeLatest(loadOrganizationBillingReports, OrganizationBillingReportSagas.loadOrganizationBillingReports);
            yield takeLatest(viewOrganizationBillingReport, OrganizationBillingReportSagas.viewOrganizationBillingReport);
            yield takeLatest(loadOrganizationBillingReportContent, OrganizationBillingReportSagas.loadOrganizationBillingReportContent);
            yield takeLatest(loadOrganizationActivityReports, OrganizationBillingReportSagas.loadOrganizationActivityReports);
            yield takeLatest(viewOrganizationActivityReport, OrganizationBillingReportSagas.viewOrganizationActivityReport);
            yield takeLatest(loadOrganizationActivityReportContent, OrganizationBillingReportSagas.loadOrganizationActivityReportContent);
        }
        catch(e: any){
            toast.error('Unable to register this module.');
            console.log(`[OrganizationBillingReportsSagas:run] the following exception has occurred`, e);
        }
    }

    private static* loadOrganizationBillingReports(action: ReturnType<typeof loadOrganizationBillingReports>){
        const { payload: orgId } = action;
	try {
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReports]` );
	    if(orgId === undefined) {
               yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
	       return; 
	    }
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReports setState to BUSY]` );
            yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orgBillingReportsResponse: AxiosResponse<OrganizationBillingReportsSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationBillingReports
                },
		orgId
            );

            if(orgBillingReportsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(orgBillingReportsResponse.status !== 200)
                throw new Error("Error communicating with Api");

	    const { organizationBillingReports } = orgBillingReportsResponse.data;
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReports set the organizationBillingReports...]` );
            yield put(organizationBillingReportsSearchSlice.actions.setOrganizationBillingReports( organizationBillingReports));
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReports - after the set of the organizationBillingReports...]` );
        }
        catch(e: any){
            toast.error('Unable to load organization billing reports.');
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReports] the following exception has occurred`, e);
        }
        finally {
            yield put(organizationBillingReportsSearchSlice.actions.setState('READY'));
        }
    }
  
    private static* viewOrganizationBillingReport(action: ReturnType<typeof viewOrganizationBillingReport>) {
	const { payload: { organizationBillingReport, rowIndex, tabIndex }} = action;
   	try {
		yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationBillingReport(organizationBillingReport));
		yield call({ context: OrganizationBillingReportSagas, fn: OrganizationBillingReportSagas.apiLoadOrganizationBillingReport}, organizationBillingReport?.reportName); 
	}
	
	catch(e: any) {
	   toast.error('Error Viewing Organization Billing Report');
	   console.log(`[OrganizationBillingReportSagas:viewOrganizationBillingReport has had an exception`,e);
	}
    } 
    
    private static* loadOrganizationBillingReportContent(action: ReturnType<typeof loadOrganizationBillingReportContent>) {
	const { payload: { organizationBillingReport, rowIndex, tabIndex }} = action;
   	try {
		yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationBillingReport(organizationBillingReport));
		yield call({ context: OrganizationBillingReportSagas, fn: OrganizationBillingReportSagas.apiLoadOrganizationBillingReportContent}, organizationBillingReport?.reportName); 
	}
	
	catch(e: any) {
	   toast.error('Error Viewing Organization Billing Report');
	   console.log(`[OrganizationBillingReportSagas:viewOrganizationBillingReport has had an exception`,e);
	}
    }
 
    private static* apiLoadOrganizationBillingReport(reportName: string | undefined){
	try {
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReport]` );
	    if(reportName === undefined) {
               yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
	       return; 
	    }
            yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orgBillingReportsResponse: AxiosResponse<OrganizationBillingReportSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationBillingReport
                },
		reportName
            );

            if(orgBillingReportsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(orgBillingReportsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            console.log("orgBillingReportsResponse: " + orgBillingReportsResponse.data.reportName); 
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReport slice action call - set the organizationBillingReport. ]`);
            yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationBillingReport(orgBillingReportsResponse.data));
            yield put(organizationBillingReportsSearchSlice.actions.setReportContent(`data:text/plain;base64,${orgBillingReportsResponse.data.reportContent}`));
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReport slice action call -  after the set of the organizationBillingReport. ]`);
        }
        catch(e: any){
            toast.error('Unable to load this organization billing report.');
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReport] the following exception has occurred`, e);
        }
        finally {
            yield put(organizationBillingReportsSearchSlice.actions.setState('READY'));
        }
    }
    
    private static* apiLoadOrganizationBillingReportContent(reportName: string | undefined){
	try {
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReport]` );
	    if(reportName === undefined) {
               yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
	       return; 
	    }
            yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orgBillingReportsResponse: AxiosResponse<OrganizationBillingReportSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationBillingReport
                },
		reportName
            );

            if(orgBillingReportsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(orgBillingReportsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            console.log("orgBillingReportsResponse: " + orgBillingReportsResponse.data.reportName); 
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReport slice action call - set the organizationBillingReport. ]`);
            yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationBillingReport(orgBillingReportsResponse.data));
            yield put(organizationBillingReportsSearchSlice.actions.setReportContent(`data:text/csv;base64,${orgBillingReportsResponse.data.reportContent}`));
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReport slice action call -  after the set of the organizationBillingReport. ]`);
        }
        catch(e: any){
            toast.error('Unable to load this organization billing report.');
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationBillingReport] the following exception has occurred`, e);
        }
        finally {
            yield put(organizationBillingReportsSearchSlice.actions.setState('READY'));
        }
    }

    private static* loadOrganizationActivityReports(action: ReturnType<typeof loadOrganizationActivityReports>){
        const { payload: orgId } = action;
	    try {
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReports]` );
            if(orgId === undefined) {
                yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            return; 
            }
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReports setState to BUSY]` );
            yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orgActivityReportsResponse: AxiosResponse<OrganizationActivityReportsSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationActivityReports
                },
		        orgId
            );

            if(orgActivityReportsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(orgActivityReportsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            const { organizationActivityReports } = orgActivityReportsResponse.data;
                console.log(`[OrganizationBillingReportsSagas:setOrganizationActivityReports set the organizationActivityReports...]` );
                yield put(organizationBillingReportsSearchSlice.actions.setOrganizationActivityReports( organizationActivityReports));
                console.log(`[OrganizationBillingReportsSagas:setOrganizationActivityReports - after the set of the organizationActivityReports...]` );
        }
        catch(e: any){
            toast.error('Unable to load organization activity reports.');
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReports] the following exception has occurred`, e);
        }
        finally {
            yield put(organizationBillingReportsSearchSlice.actions.setState('READY'));
        }
    }
  
    private static* viewOrganizationActivityReport(action: ReturnType<typeof viewOrganizationActivityReport>) {
	const { payload: { organizationActivityReport, rowIndex, tabIndex }} = action;
   	try {
		yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationBillingReport(organizationActivityReport));
		yield call({ context: OrganizationBillingReportSagas, fn: OrganizationBillingReportSagas.apiLoadOrganizationActivityReport}, organizationActivityReport?.reportId); 
	}
	
	catch(e: any) {
	   toast.error('Error Viewing Organization Billing Report');
	   console.log(`[OrganizationBillingReportSagas:viewOrganizationBillingReport has had an exception`,e);
	}
    } 
    
    private static* loadOrganizationActivityReportContent(action: ReturnType<typeof loadOrganizationActivityReportContent>) {
	const { payload: { organizationActivityReport, rowIndex, tabIndex }} = action;
   	try {
		yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationActivityReport(organizationActivityReport));
		yield call({ context: OrganizationBillingReportSagas, fn: OrganizationBillingReportSagas.apiLoadOrganizationActivityReportContent}, organizationActivityReport?.reportId); 
	}
	
	catch(e: any) {
	   toast.error('Error Viewing Organization Activity Report');
	   console.log(`[OrganizationBillingReportSagas:viewOrganizationActivityReport has had an exception`,e);
	}
    }
 
    private static* apiLoadOrganizationActivityReport(reportId: number | undefined){
	try {
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReport]` );
	    if(reportId === undefined) {
               yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
	       return; 
	    }
            yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orgActivityReportsResponse: AxiosResponse<OrganizationActivityReportSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationActivityReport
                },
		        reportId
            );

            if(orgActivityReportsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(orgActivityReportsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            console.log("orgActivityReportsResponse ReportId: " + orgActivityReportsResponse.data.reportId); 
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReport slice action call - set the organizationBillingReport. ]`);
            yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationActivityReport(orgActivityReportsResponse.data));
            yield put(organizationBillingReportsSearchSlice.actions.setReportContent(orgActivityReportsResponse.data.reportContent));
            console.log(`[OrganizationBillingReportsSagas:setOrganizationBillingReport slice action call -  after the set of the organizationBillingReport. ]`);
        }
        catch(e: any){
            toast.error('Unable to load this organization activity report.');
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReport] the following exception has occurred`, e);
        }
        finally {
            yield put(organizationBillingReportsSearchSlice.actions.setState('READY'));
        }
    }
    
    private static* apiLoadOrganizationActivityReportContent(reportId: number | undefined){
	try {
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReport]` );
            if(reportId === undefined) {
                yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            return; 
            }
            yield put(organizationBillingReportsSearchSlice.actions.setState('BUSY'));
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const orgActivityReportsResponse: AxiosResponse<OrganizationActivityReportSearchResponse> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationActivityReport
                },
		        reportId
            );

            if(orgActivityReportsResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(orgActivityReportsResponse.status !== 200)
                throw new Error("Error communicating with Api");

            console.log("orgActivityReportsResponse: " + orgActivityReportsResponse.data.reportId); 
            console.log(`[OrganizationBillingReportsSagas:setOrganizationActivityReport slice action call - set the organizationActivityReport. ]`);
            yield put(organizationBillingReportsSearchSlice.actions.setSelectedOrganizationActivityReport(orgActivityReportsResponse.data));
            yield put(organizationBillingReportsSearchSlice.actions.setReportContent(`${orgActivityReportsResponse.data.reportContent}`));
            console.log(`[OrganizationBillingReportsSagas:setOrganizationActivityReport slice action call -  after the set of the organizationActivityReport. ]`);
        }
        catch(e: any){
            toast.error('Unable to load this organization activity report.');
            console.log(`[OrganizationBillingReportsSagas:loadOrganizationActivityReport] the following exception has occurred`, e);
        }
        finally {
            yield put(organizationBillingReportsSearchSlice.actions.setState('READY'));
        }
    }
     

}
